import { STATUS, REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { INeoAction } from './../Actions.interface';
import { convertStringObjectToBooleanKeyValues } from '../../Helpers/Parsers.helper';

interface LoadingState {
  [x: string]: boolean;
}

export const INITIAL_STATE: LoadingState = convertStringObjectToBooleanKeyValues(REQUEST_ACTIONS);

export default (state = INITIAL_STATE, action: INeoAction) => {
  const { name, status } = action;

  if (name) {
    switch (status) {
      case STATUS.LOADING: {
        if (state[name]) {
          console.warn(`Event ${name} was fired multiple times in parallel`);
        }
        return { ...state, [name]: true };
      }

      case STATUS.SUCCESS: {
        return { ...state, [name]: false };
      }

      case STATUS.FAILURE:
      case STATUS.UNAUTHORIZED: {
        return { ...state, [name]: false };
      }

      default:
        return state;
    }
  }

  return state;
};
